export const navButton = [
  { id: 1, text: "Get in Touch", onclick: "/contactus" },
];
